export default "__VITE_ASSET__1SZlgX6V__"